import { useEffect, useState } from 'react';
import isRunningInBrowser from '../../utils/isRunningInBrowser';
import isAPISupported from '../../utils/isAPISupported';

const errorMessage = 'matchMedia API is not supported, this could happen both because window.matchMedia is not supported by'
  + ' your current browser or the useMediaQuery hook is being used whilst server side rendering.';

export default function useMediaQuery(mediaQuery) {
  const canBeUsed = !(!isRunningInBrowser() || !isAPISupported('matchMedia'));
  if (!canBeUsed) {
    console.error(errorMessage);
  }
  const [isMatching, setIsMatching] = useState(canBeUsed && !!window.matchMedia(mediaQuery).matches);

  useEffect(() => {
    let mediaQueryList, windowChangeHandler;
    if (canBeUsed) {
      mediaQueryList = window.matchMedia(mediaQuery);
      windowChangeHandler = () => setIsMatching(!!mediaQueryList.matches);
      mediaQueryList.addEventListener('change', windowChangeHandler);
      windowChangeHandler();
    }
    else {
      setIsMatching(false);
    }
    return () => {
      if(canBeUsed) mediaQueryList.removeEventListener('change', windowChangeHandler);
    };
  }, [mediaQuery, canBeUsed]);

  return isMatching;
};

